import toast from '@/components/modal/ToastShow'
export default (Vue) => {
  let ToastComp = Vue.extend(toast)
  function showToast (msg, duration = 3000) {
    let toastDom = new ToastComp({
      data () {
        return {
          show: true,
          msg: typeof msg === 'object' ? msg.msg : msg
        }
      }
    }).$mount()
    document.body.appendChild(toastDom.$el)
    setTimeout(() => {
      toastDom.show = false
    }, duration)
  }
  Vue.prototype.$toast = showToast
}
